import {
  getRatingResultsRequest,
  getRatingResultsResponse,
} from '@core-api/presentation/presentation/interactive-content/{interactive_content_id}/rating-results';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchRatingGridResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useFetchRatingGridResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseFetchRatingGridResultsParams) => {
  const requestParams = { interactiveContentId };
  const cacheKey = adminKey
    ? getFetchResultsCacheKey('rating-grid', adminKey, sessionId)
    : null;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldFetchResults,
    sessionId,
    getRequest: getRatingResultsRequest,
    getResponse: getRatingResultsResponse,
  });
};
